import React from 'react';
import { observer, inject } from 'mobx-react';
import { upperFirst } from 'lodash';

import Container from './Container';
import LineItem from './LineItem';
import BonusLineItem from './BonusLineItem';

export default inject('page')(
  observer(({ page }) => (
    <Container>
      <LineItem label={upperFirst(page.purchase_token.title)}>{page.purchase_token.price}</LineItem>
      {page.shipping_service && (
        <>
          {!page.applyingBonus && page.bonus_available !== 0 && (
            <BonusLineItem onClick={page.applyBonus} label="Apply Reward Credit">{page.bonus_available}</BonusLineItem>
          )}
          {page.applyingBonus && page.bonus_available !== 0 && (
            <BonusLineItem label="...">{page.bonus_available}</BonusLineItem>
          )}
          {!page.applyingBonus && page.bonus_applied !== 0 && (
            <LineItem label="Reward Credit Applied" negative={true}>{page.bonus_applied}</LineItem>
          )}
          <LineItem label="Shipping">{page.shipping_service.price}</LineItem>
          <LineItem label="Total">{page.shipping_service.price + page.purchase_token.price - (page.bonus_applied ? page.bonus_applied : 0)}</LineItem>
        </>
      )}
    </Container>
  )),
);
